const types = {
  SET_CURRENT_VOUCHER: 'SET_CURRENT_VOUCHER'
};
const state = {
  currentVoucher: null
}
const mutations = {
  [types.SET_CURRENT_VOUCHER]: (state, value) => {
    state.currentVoucher = value;
  }
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
